import React from 'react';

export default function Downloads() {
  return <div>Downloads</div>;
}
